import React, {useContext} from 'react'
import BannerHome from '../bannerHome/bannerHome'
import ParticipationSteps from '../../molecules/participationSteps/participationSteps'
import SectionAwards from '../sectionAwards/sectionAwards'
import BannerKnowMore from '../bannerKnowMore/bannerKnowMore'
import TermsContainer from "../../atoms/termsContainer/termsContainer";
import BannerKit from "../../molecules/bannerKit/bannerKit";
import {Context} from "../../../context/app-context";

const ContentHome = () => {
  const { dispatch } = useContext(Context)

  React.useEffect(() => {
    dispatch({ type: 'clear-modal' })

  }, []);

  return (
    <>
      <BannerHome/>
      {/* <BannerKit /> */}
      <ParticipationSteps section='home'/>
      <SectionAwards/>
      <BannerKnowMore/>
      <TermsContainer/>
    </>
  )
}

export default ContentHome
